export function checkUrlIsValid(link = "") {
  try {
    new URL(link);
    return true;
  } catch {
    return false;
  }
}
